var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "tag-solid",
    d: "M0,8.864V1.688A1.687,1.687,0,0,1,1.688,0H8.864a1.688,1.688,0,0,1,1.193.494l7.449,7.449a1.688,1.688,0,0,1,0,2.386L10.33,17.506a1.688,1.688,0,0,1-2.386,0L.494,10.057A1.688,1.688,0,0,1,0,8.864ZM3.938,2.25A1.688,1.688,0,1,0,5.625,3.938,1.687,1.687,0,0,0,3.938,2.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagSolid);
export default __webpack_public_path__ + "static/media/tag-solid.30cd50ca33bd4f734e75af2c5eb46268.svg";
export { ForwardRef as ReactComponent };